"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.observeScroll = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _feature = require("../feature");
/**
 * `observeScroll` is a function that uses the IntersectionObserver API to determine whether a specified element is intersecting with a given root.
 *
 * @param {HTMLElement} element - The HTMLElement that you want to observe.
 * @param {string} rootMargin - A string which specifies the margins around the root. You can specify values for top, right, bottom and left margins. The values can be percentages or pixels. For example, '10px 20px 30px 40px'.
 * @param {Function} callback - A function that will be called whenever the intersection status of the observed element changes. This function receives a boolean argument that is `true` when the observed element is intersecting with the root (i.e., when the intersection ratio is greater than 0), and `false` when it is not.
 *
 * @returns {Function} - A function that, when called, will stop observing the specified element.
 */
const observeScroll = (element, rootMargin, callback) => {
  const scrollContainer = (0, _feature.ifFeature)('encore', document.getElementById('js-GlobalScrollContainer')); // TODO: Replace with getScrollContainer() once SrollManager is updated.
  if (!element) {
    console.error(`No element provided to observeScroll.`);
    return;
  }
  const observer = new IntersectionObserver(entries => {
    (0, _forEach.default)(entries).call(entries, entry => {
      callback(entry.isIntersecting);
    });
  }, {
    root: scrollContainer,
    rootMargin: rootMargin,
    threshold: 0
  });
  observer.observe(element);
  return () => observer.unobserve(element);
};
exports.observeScroll = observeScroll;